import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { AreaWill } from './area-will';
import { AreaProbate } from './area-probate';
import { AreaGuardianship } from './area-guardianship';
import { AreaRealEstate } from './area-real-estate';
import { AreaStartup } from './area-startup';
import { AreaNonprofit } from './area-nonprofit';
import { AreaHousing } from './area-housing';
import AOS from 'aos';

import css from '../styles/areas.css';

const { Component } = React;

class Areas extends Component {
  componentDidMount() {
    AOS.refreshHard();
    let body = $('body');
    let hasClass = body.hasClass('light-page');
    if (!hasClass) {
      body.addClass('light-page');
    }
  }

  componentWillUnmount() {
    let body = $('body');
    body.removeClass('light-page');
  }

  render() {
    return (
      <div className="areas">
        <AreaWill />
        <AreaProbate />
        <AreaGuardianship />
        <div class="areas-grid">
          <AreaRealEstate />
          <AreaStartup />
          <AreaNonprofit />
          <AreaHousing />
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    areas: state.areas
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const AreasContainer = connect(mapStateToProps, mapDispatchToProps)(Areas);

export {Areas, AreasContainer};



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/areas.js